import { useApplicationStateValue } from "../../../application/Application";
import { Box, Flex } from "reflexbox/styled-components";
import FavoriteToggleButton, { StyledFavButton } from "../../../components/buttons/favorite-toggle-button/FavoriteToggleButton";
import ImageSlider from "../../../components/image-slider/ImageSlider";
import React from "react";
import styled from "styled-components";

const StyledLabel = styled(Box)`
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    word-wrap: break-word;
    padding-top: 2%;
    padding-right: 3%;
    line-height: 27px;
    flex: 2;
    color: ${({ theme }) => theme.colors.white};
`;

const StyledFavorites = styled(StyledFavButton)`
    flex: 2;
    align-content: center;
`;

const StyledLabelAndFavorites = styled(Flex)`
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
`;

const StyledStartTimeLabelAndRoom = styled(Box)`
    display: inline;
    padding-left: 5%;
`;

const StyledStartTime = styled.span`
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;

const StyledRoom = styled.span`
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights.light};
`;

const PanelHeader = ({ id }) => {
    const {
        appData: { forumPanels }
    } = useApplicationStateValue();
    return (
        <div>
            <StyledLabelAndFavorites paddingX={[3, 4]} paddingY={[1, 2]}>
                <StyledLabel fontSize={[6]}>{forumPanels[id].label}</StyledLabel>
                <Box pt="3%">
                    <FavoriteToggleButton id={+id} renderItem={StyledFavorites} />
                </Box>
            </StyledLabelAndFavorites>
            <StyledStartTimeLabelAndRoom paddingX={[3, 4]} fontSize={[3]}>
                <StyledStartTime>{`${forumPanels[id].startTimeLabel}, `}</StyledStartTime>
                <StyledRoom>{forumPanels[id].room}</StyledRoom>
            </StyledStartTimeLabelAndRoom>
            <ImageSlider id={id} />
        </div>
    );
};

export default PanelHeader;
